import type { CandidateProfile } from "@applicant-reviewer/api";

interface ProfileCompletenessBarProps {
  profile: CandidateProfile;
}

interface FieldStatus {
  label: string;
  complete: boolean;
}

function getFieldStatuses(profile: CandidateProfile): FieldStatus[] {
  return [
    { label: "First name", complete: Boolean(profile.firstName) },
    { label: "Last name", complete: Boolean(profile.lastName) },
    { label: "Phone", complete: Boolean(profile.phone) },
    { label: "ID (front)", complete: Boolean(profile.idFrontMediaId) },
    { label: "ID (back)", complete: Boolean(profile.idBackMediaId) },
  ];
}

export default function ProfileCompletenessBar({ profile }: ProfileCompletenessBarProps) {
  const fields = getFieldStatuses(profile);
  const completedCount = fields.filter((f) => f.complete).length;
  const totalCount = fields.length;
  const percentage = Math.round((completedCount / totalCount) * 100);

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-semibold text-gray-700">Profile completeness</span>
        <span className="text-sm font-bold text-[#0156FF]">{percentage}%</span>
      </div>
      <div className="w-full bg-gray-100 rounded-full h-2 mb-3">
        <div
          className="bg-[#0156FF] h-2 rounded-full transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className="flex flex-wrap gap-2">
        {fields.map((field) => (
          <span
            key={field.label}
            className={`text-xs px-2 py-1 rounded-full font-medium ${
              field.complete
                ? "bg-green-100 text-green-700"
                : "bg-gray-100 text-gray-500"
            }`}
          >
            {field.complete ? "✓ " : ""}{field.label}
          </span>
        ))}
      </div>
    </div>
  );
}
